import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import ResourcePage from "@/components/ResourcePage";
import { Badge } from "@/components/Common";
import { PageHeader, EmptyState } from "@/components/Common";

export default function CareersAdmin() {
  const [departments, setDepartments] = useState([]);
  const [applications, setApplications] = useState([]);
  useEffect(() => {
    api.get("/departments").then(({ data }) => setDepartments(data));
    api.get("/job-applications").then(({ data }) => setApplications(data));
  }, []);
  return (
    <div className="space-y-8">
      <ResourcePage
        endpoint="/careers"
        testidPrefix="career"
        eyebrow="Website · Careers"
        title="Job Postings"
        subtitle="Roles published here appear on /site/careers and accept applications without login."
        ctaLabel="Post job"
        fields={[
          { name: "title", label: "Job title", required: true },
          { name: "department", label: "Department", type: "select", options: departments.map((d) => d.name) },
          { name: "location", label: "Location", placeholder: "Kampala, Uganda" },
          { name: "employment_type", label: "Employment type", type: "select", default: "full_time",
            options: ["full_time", "part_time", "contract", "internship"] },
          { name: "description", label: "Job description", type: "textarea", required: true },
          { name: "requirements", label: "Requirements", type: "textarea" },
          { name: "closing_date", label: "Closing date", type: "date" },
        ]}
        columns={[
          { key: "title", label: "Role" },
          { key: "department", label: "Department" },
          { key: "location", label: "Location" },
          { key: "employment_type", label: "Type", render: (i) => (i.employment_type || "").replaceAll("_", " ") },
          { key: "is_open", label: "Status", render: (i) => <Badge tone={i.is_open === false ? "gray" : "emerald"}>{i.is_open === false ? "Closed" : "Open"}</Badge> },
        ]}
        searchKeys={["title", "department", "location"]}
      />
      <div>
        <PageHeader eyebrow="Website · Careers" title="Applications received"
          subtitle="Applicants who applied via /site/careers — review and contact." />
        {applications.length === 0 ? (
          <EmptyState title="No applications yet" hint="When candidates submit applications, they'll appear here." />
        ) : (
          <div className="bg-white border border-gray-200 rounded-md overflow-hidden">
            <table className="min-w-full text-sm" data-testid="applications-table">
              <thead className="bg-gray-50">
                <tr>{["Applied", "Name", "Email", "Phone", "Role", "Status"].map((h) => (
                  <th key={h} className="text-left text-xs font-bold text-gray-600 uppercase tracking-wider px-4 py-3">{h}</th>
                ))}</tr>
              </thead>
              <tbody>
                {applications.map((a) => (
                  <tr key={a.id} className="border-t border-gray-100 hover:bg-gray-50">
                    <td className="px-4 py-3 text-xs text-gray-600">{new Date(a.created_at).toLocaleDateString()}</td>
                    <td className="px-4 py-3 font-medium text-gray-900">{a.full_name}</td>
                    <td className="px-4 py-3 text-gray-700">{a.email}</td>
                    <td className="px-4 py-3 text-gray-700">{a.phone}</td>
                    <td className="px-4 py-3 text-gray-700">{a.career_title || "—"}</td>
                    <td className="px-4 py-3"><Badge tone="emerald">{a.status}</Badge></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}
